import React, { useEffect } from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import { MuiThemeProvider } from '@material-ui/core/styles';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';

import totangoTheme from 'Theme/totangoTheme';

function MaterialFormControl({
	className,
	inputComponent,
	label,
	fullWidth,
	setLabelWidth,
	required,
	...restProps
}) {
	const inputLabel = React.useRef(null);
	useEffect(() => {
		setLabelWidth(inputLabel.current ? inputLabel.current.offsetWidth : 0);
	}, [setLabelWidth]);

	return (
		<MuiThemeProvider theme={totangoTheme}>
			<FormControl className={className} fullWidth={fullWidth} required={required} {...restProps}>
				{label ? (
					<InputLabel ref={inputLabel} htmlFor="label">
						{label}
					</InputLabel>
				) : (
					''
				)}
				{inputComponent}
			</FormControl>
		</MuiThemeProvider>
	);
}

MaterialFormControl.defaultProps = {
	className: '',
	label: undefined,
	fullWidth: false,
	setLabelWidth: noop,
};

MaterialFormControl.propTypes = {
	className: PropTypes.string,
	inputComponent: PropTypes.element.isRequired,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	fullWidth: PropTypes.bool,
	setLabelWidth: PropTypes.func,
};

export default MaterialFormControl;
